import * as React from 'react';
import { Grid, Switch as SwitchMui } from '@mui/material';
import { Chip, Text } from '.';
import AppService from '../services/app.service';

interface Props {
  id?: string;
  name: string;
  label?: string;
  value: string;
  options?: any;
  readOnly?: boolean;
  disableMargin?: boolean;
  onChange?: (fieldName: string, value?: string) => void;
  error?: string;
}

export const InputSwitch: React.FunctionComponent<Props> = (props) => {
  const options = props.options?.map((d: any) => d.name) || ['yes', 'no'];
  const [value, setValue] = React.useState('');
  const [isTrue, setIsTrue] = React.useState(false);
  const onChangeSwitch = (e: React.ChangeEvent<HTMLInputElement>) => {
    setValue(options[+!e.target.checked]);
    props.onChange?.(props.name, options[+!e.target.checked]);
  }

  React.useEffect(() => {
    setValue(props.value);
    setIsTrue(value === options[0]);

  }, [props.value, value])

  return (
    <Grid id={props.id || props.name} mt={props.disableMargin? 0 : 2} mb={props.disableMargin? 0: 3}>
        <Text label={props.label} size='small' color='text.secondary' />
        {props.readOnly?
          <Chip label={AppService.strCapitalize(value)} type={isTrue? 'primary' : 'default'}/>
        : <>
          <SwitchMui
            checked={isTrue}
            size='small'
            color={isTrue? 'primary' : 'default'}
            disabled={props.readOnly}
            onChange={onChangeSwitch}
          /> 
          {AppService.strCapitalize(value)}
          </>
        }
        <Text label={props.error} size='small' color='red'/>
    </Grid>
  )
}